import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { GoogleMap, useJsApiLoader, Marker, InfoWindow, MarkerClusterer } from "@react-google-maps/api";
import { Box, Button, CircularProgress, Paper, TextField, Tooltip } from "@mui/material";
import { Autocomplete as MuiAutocomplete } from "@mui/material";
import Service from '../../config/networkutils';
import { useSnackbar, withSnackbar } from "notistack";
import Auth from '../../utils/authenticate';
import moment from "moment";
import { Checkbox } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { getDataIsdeletedFalse } from "../Helper/CommonThings";


const libraries = ['places', 'drawing', 'geometry'];

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const UNITED_KINGDOM_BOUNDS = {
    north: 60.15456,
    south: 49.10319,
    west: -7.64133,
    east: 2.75159,
};

const token = Auth.token()

const MapComponent = forwardRef((props, ref) => {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: 'AIzaSyBbb2sikpbMH8oqAkF1O8vdgjpN4ydJM9w',
        libraries
    })
    const [activeMarker, setActiveMarker] = useState(null);
    const [center, setCenter] = useState({ lat: 51.509865, lng: -0.118092 })
    const [markers, setMarkers] = useState([{ path: { lat: 51.509865, lng: -0.118092 } }])
    const [markersList, setMarkersList] = useState([])
    const [zoom, setZoom] = useState(6);
    const [loading, setLoading] = useState(true)
    const [bounds] = useState(null)
    const mapRef = useRef();
    const { enqueueSnackbar } = useSnackbar();
    const [gateArr, setGateArr] = useState([])
    const [sectorArr, setSectorArr] = useState([])
    const [operativeLead, setOperativeLead] = useState([])
    const [selectedGate, setSelectedGate] = useState([])
    const [selectedSector, setSelectedSector] = useState(null)
    const [selectedOperativeLead, setSelectedOperativeLead] = useState(null)
    const [liveArchiveValue, setLiveArchiveValue] = useState(0)
    const [isStreetViewMode, setIsStreetViewMode] = useState(false)
    const streetViewListenerRef = useRef(null)
    // const infowindowRef = useRef(null)


    const handleActiveMarker = (marker, latitude, longitude, id) => {
        if (id === activeMarker) {
            return;
        }
        setActiveMarker(id);
    }

    function getDarkMode() {
        if (!localStorage.getItem("theme_mode")) {
            var mode = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
            return mode
        } else if (localStorage.getItem("theme_mode") === 'dark') {
            return 'dark'
        } else if (localStorage.getItem("theme_mode") === 'light') {
            return 'light'
        }
    }


    useImperativeHandle(ref, () => ({
        clearFilters: () => {
            setSelectedSector(null)
            setSelectedGate(null)
            setSelectedOperativeLead(null)
            getCRMData(liveArchiveValue)
        },
        handleRefresh: (value) => {
            setLiveArchiveValue(value)
            getCRMData(value)
        },
    }))

    const clearFilters = () => {
        setSelectedSector(null)
        setSelectedGate([])
        setSelectedOperativeLead(null)
        getCRMData(liveArchiveValue)
    }

    // const onLoadDrawingManager = drawingManager => {
    //     drawingManagerRef.current = drawingManager;
    // }

    // const onOverlayComplete = ($overlayEvent) => {
    //     drawingManagerRef.current.setDrawingMode(null);
    //     let overlayLocalEvent = overlayEvent
    //     overlayLocalEvent.push($overlayEvent)
    //     setOverlayEvent(overlayLocalEvent)
    //     if ($overlayEvent.type === window.google.maps.drawing.OverlayType.POLYGON) {
    //         const newPolygon = $overlayEvent.overlay.getPath()
    //             .getArray()
    //             .map(latLng => ({ lat: latLng.lat(), lng: latLng.lng() }))

    //         // start and end point should be same for valid geojson
    //         const startPoint = newPolygon[0];
    //         newPolygon.push(startPoint);
    //         // $overlayEvent.overlay?.setMap(null);
    //         // setPolygons(newPolygon);
    //     }
    // }

    // const drawingManagerOptions = {
    //     drawingControl: true,
    //     drawingControlOptions: {
    //         position: window.google?.maps?.ControlPosition?.BOTTOM_CENTER,
    //         drawingModes: [
    //             window.google?.maps?.drawing?.OverlayType?.POLYGON,
    //         ],
    //     },
    //     size: 20,
    // }

    // const onLoadPolygon = (polygon, index) => {
    //     polygonRefs.current[index] = polygon;
    // }

    // const onClickPolygon = (index) => {
    //     activePolygonIndex.current = index;
    // }

    // const onEditPolygon = (index) => {
    //     const polygonRef = polygonRefs.current[index];
    //     if (polygonRef) {
    //         const coordinates = polygonRef.getPath()
    //             .getArray()
    //             .map(latLng => ({ lat: latLng.lat(), lng: latLng.lng() }));

    //         const allPolygons = [...polygons];
    //         allPolygons[index] = coordinates;
    //         setPolygons(allPolygons)
    //     }
    // }


    // const showMarkers = (paths, bounds) => {
    //     let geojson = []
    //     let path = []
    //     let polygonDrawn = {}
    //     for (let index = 0; index < paths.length; index++) {
    //         const element = paths[index];
    //         path.push({ 'lng': element.lng, 'lat': element.lat })
    //         geojson.push(`[${element.lng()},${element.lat()}]`)
    //         if (index === paths.length - 1) {
    //             geojson.push(geojson[0])
    //         }
    //     }
    //     polygonDrawn.path = path

    // }

    const getCRMData = (value) => {
        setLoading(true)
        let url = `/api/crm/fetch_crm_data_for_map/?is_trashed=False&archive_reason=${value}`
        if (selectedGate) {
            let id = ''
            for (let index = 0; index < selectedGate.length; index++) {
                const element = selectedGate[index];
                if (index === selectedGate.length - 1) {
                    id = id + element.id
                } else {
                    id = id + element.id + ','
                }
            }
            url = url + '&gate_stage=' + id
        }
        if (selectedSector) {
            url = url + '&discipline=' + selectedSector.id
        }
        if (selectedOperativeLead) {
            url = url + '&operation_leads=' + selectedOperativeLead.id
        }
        Service.get(url, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let data = getDataIsdeletedFalse(res.data)
                let listData = []
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    if (element.latitude && element.longitude) {
                        listData.push(element)
                    }
                }
                setMarkersList(listData)
                setMarkers(data)
                setLoading(false)
                setZoom(6)
                setLoading(false)
            }).catch(error => {
                console.log(error)
                setLoading(false)
                if(error.status === 403){
                    enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    })
                } else {
                    enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                }
            })
    }

    const getAllList = () => {
        return new Promise((resolve, reject) => {
            Service.get('/api/crm/crmlinkedcolumns_api/', {
                headers: {
                    Authorization: "Token " + token,
                },
            }).then(res => {
                 let obj = {}
                Object.keys(res.data).forEach(key => {
                    obj[key] = getDataIsdeletedFalse(res.data[key])
                })
                resolve(obj)
            }).catch(error => reject(error))
        })
    }


    const getOperativesLead = () => {
        return new Promise((resolve, reject) => {
            Service.get('/api/ownerdelivery/get_with_delete_status/', {
                headers: {
                    Authorization: "Token " + token,
                },
            }).then(res => {
                let resData = getDataIsdeletedFalse(res.data)
                resolve(resData)
            }).catch(error => reject(error))
        })
    }



    useEffect(() => {
        Promise.all([
            getAllList(),
            getOperativesLead()
        ]).then(res => {
            console.log(res)
            for (let index = 0; index < res[0]['gate_stage'].length; index++) {
                const element = res[0]['gate_stage'][index];
                if (element.name === 'Gate 5') {
                    setSelectedGate([element])
                }
            }
            setSectorArr(res[0]['subsector'])
            setGateArr(res[0]['gate_stage'])
            setOperativeLead(res[1])
        }).catch(err => {
            console.log(err)
            this.setState({ isLoading: false })
            this.props.enqueueSnackbar('Something went wrong!', {
                variant: 'error'
            });
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // const onLoadAutocomplete = (autocomplete) => {
    //     autocompleteRef.current = autocomplete
    // }

    // const handlePlaceChanged = () => {
    //     const { geometry } = autocompleteRef.current.getPlace();
    //     mapRef.current.setZoom(15)
    //     const bounds = new window.google.maps.LatLngBounds();
    //     if (geometry.viewport) {
    //         bounds.union(geometry.viewport);
    //     } else {
    //         bounds.extend(geometry.location);
    //     }
    //     mapRef.current.fitBounds(bounds);
    // }

    // const inputStyle = {
    //     boxSizing: 'border-box',
    //     width: '300px',
    //     height: '40px',
    //     padding: '0 12px',
    //     borderRadius: '30px',
    //     boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
    //     fontSize: '14px',
    //     outline: 'none',
    //     textOverflow: 'ellipses',
    //     backgroundColor: getDarkMode() === 'dark' ? 'black' : 'primary',
    //     color: getDarkMode() === 'dark' ? 'white' : 'black',
    //     border: getDarkMode() === 'dark' ? '1px solid #dd7c0d' : '1px solid #005c99',
    // }

    useEffect(() => {
        getCRMData(liveArchiveValue)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedGate, selectedSector, selectedOperativeLead])

    useEffect(() => {
        return () => {
            if (streetViewListenerRef.current) {
                streetViewListenerRef.current.remove()
            }
        }
    }, [])

    // const getAreaforPolygon = (polygon) => {
    //     let area = window.google.maps.geometry.spherical.computeArea(polygon.getPath())
    //     return area
    // }


    return (
        isLoaded ?
            loading ? <div style={{ height: (window.innerHeight - 64) + "px", width: "100%", position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <h1><CircularProgress color={getDarkMode() === 'dark' ? 'secondary' : 'primary'} /></h1>
            </div> :
                <div style={{ height: (window.innerHeight - 64) + "px", width: "100%", position: 'relative', }}>
                    <GoogleMap
                        mapContainerStyle={{ width: "100%", height: "100%" }}
                        center={center}
                        ref={mapRef}
                        zoom={zoom}
                        setBounds={bounds}
                        onLoad={map => {
                            mapRef.current = map;
                            const panorama = map.getStreetView()
                            setIsStreetViewMode(panorama.getVisible())
                            if (streetViewListenerRef.current) {
                                streetViewListenerRef.current.remove()
                            }
                            streetViewListenerRef.current = panorama.addListener('visible_changed', () => {
                                setIsStreetViewMode(panorama.getVisible())
                            })
                        }}
                        onClick={() => {
                            // if (infowindowRef.current) {
                            //     setActiveMarker(null);
                            // }
                        }}
                        options={{
                            mapTypeId: 'roadmap',
                            // mapTypeId: props.selectedLayer === 0 ? 'roadmap' : props.selectedLayer === 1 ? 'satellite' : props.selectedLayer === 2 ? 'terrain' : props.selectedLayer === 3 ? 'hybrid' : 'hybrid',
                            zoomControl: true,
                            mapTypeControl: false,
                            restriction: {
                                latLngBounds: UNITED_KINGDOM_BOUNDS,
                                strictBounds: false,
                            },
                            styles:
                                // getDarkMode() === 'dark' ?
                                //     [
                                //         { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
                                //         { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
                                //         { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
                                //         {
                                //             featureType: "administrative.locality",
                                //             elementType: "labels.text.fill",
                                //             stylers: [{ color: "#d59563" }],
                                //         },
                                //         {
                                //             featureType: "poi",
                                //             elementType: "labels.text.fill",
                                //             stylers: [{ color: "#d59563" }],
                                //         },

                                //         {
                                //             featureType: "road",
                                //             elementType: "geometry",
                                //             stylers: [{ color: "#38414e" }],
                                //         },
                                //         {
                                //             featureType: "road",
                                //             elementType: "geometry.stroke",
                                //             stylers: [{ color: "#212a37" }],
                                //         },
                                //         {
                                //             featureType: "road",
                                //             elementType: "labels.text.fill",
                                //             stylers: [{ color: "#9ca5b3" }],
                                //         },
                                //         {
                                //             featureType: "road.highway",
                                //             elementType: "geometry",
                                //             stylers: [{ color: "#746855" }],
                                //         },
                                //         {
                                //             featureType: "road.highway",
                                //             elementType: "geometry.stroke",
                                //             stylers: [{ color: "#1f2835" }],
                                //         },
                                //         {
                                //             featureType: "road.highway",
                                //             elementType: "labels.text.fill",
                                //             stylers: [{ color: "#f3d19c" }],
                                //         },
                                //         {
                                //             featureType: "transit",
                                //             elementType: "geometry",
                                //             stylers: [{ color: "#2f3948" }],
                                //         },
                                //         {
                                //             featureType: "transit.station",
                                //             elementType: "labels.text.fill",
                                //             stylers: [{ color: "#d59563" }],
                                //         },
                                //         {
                                //             featureType: "water",
                                //             elementType: "geometry",
                                //             stylers: [{ color: "#17263c" }],
                                //         },
                                //         {
                                //             featureType: "water",
                                //             elementType: "labels.text.fill",
                                //             stylers: [{ color: "#515c6d" }],
                                //         },
                                //         {
                                //             featureType: "water",
                                //             elementType: "labels.text.stroke",
                                //             stylers: [{ color: "#17263c" }],
                                //         },

                                //         {
                                //             featureType: 'poi',
                                //             elementType: 'labels',
                                //             stylers: [{ visibility: 'off' }]
                                //         },
                                //         {
                                //             featureType: "transit",
                                //             elementType: "labels.icon",
                                //             stylers: [{ visibility: "off" }],
                                //         },
                                //     ] :
                                [{
                                    featureType: 'poi',
                                    elementType: 'labels',
                                    stylers: [{ visibility: 'off' }]
                                },
                                {
                                    featureType: "transit",
                                    elementType: "labels.icon",
                                    stylers: [{ visibility: "off" }],
                                },]
                        }}
                    >
                        {/* <Box sx={{ position: 'absolute', bottom: 20, left: 10 }}>
                            <Tooltip title="Layers">
                                <Paper sx={{ padding: 1 }}>
                                    <VisibilityIcon fontSize="medium" sx={{ cursor: 'pointer' }} onClick={() => { if (props.openLayers) { props.openLayers() } }} />
                                </Paper>
                            </Tooltip>
                        </Box> */}
                        {!isStreetViewMode ? <Box sx={{ position: 'absolute', top: 10, left: 20, display: 'flex', flexDirection: 'row' }}>
                            <Paper sx={{ display: 'flex', borderRadius: '25px', marginLeft: 2, width: 300, }}>
                                <MuiAutocomplete
                                    disablePortal
                                    options={markersList}
                                    sx={{ width: 300, borderRadius: '30px' }}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            setZoom(16);
                                            setTimeout(() => {
                                                setCenter({ lat: newValue.latitude, lng: newValue.longitude });
                                            }, 100);
                                            handleActiveMarker(markersList.indexOf(newValue), newValue.latitude, newValue.longitude, newValue.id)
                                        } else {
                                            setCenter({ lat: 51.509865, lng: -0.118092 });
                                            setZoom(6)
                                        }
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Search by Projects" size="small" sx={{ width: 300, '& .MuiOutlinedInput-root': { '& fieldset': { borderRadius: 30, }, } }} />}
                                />
                            </Paper>
                            <Paper sx={{ display: 'flex', borderRadius: '25px', marginLeft: 2, width: 300, }}>
                                <MuiAutocomplete
                                    disablePortal
                                    size="small"
                                    options={sectorArr}
                                    value={selectedSector}
                                    sx={{ width: 300, borderRadius: '30px' }}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            setSelectedSector(newValue)
                                        } else {
                                            setSelectedSector(null)
                                        }
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Search Discipline" size="small" sx={{ width: 300, '& .MuiOutlinedInput-root': { '& fieldset': { borderRadius: 30, }, } }} />}
                                />
                            </Paper>
                            <Paper sx={{ display: 'flex', borderRadius: '25px', marginLeft: 2, width: 300, }}>
                                <MuiAutocomplete
                                    disablePortal
                                    size="small"
                                    options={operativeLead}
                                    value={selectedOperativeLead}
                                    sx={{ width: 300, borderRadius: '30px' }}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            setSelectedOperativeLead(newValue)
                                        } else {
                                            setSelectedOperativeLead(null)
                                        }
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Search Operations Lead" size="small" sx={{ width: 300, '& .MuiOutlinedInput-root': { '& fieldset': { borderRadius: 30, }, } }} />}
                                />
                            </Paper>
                            <Paper sx={{ display: 'flex', borderRadius: '25px', marginLeft: 2, width: 300, }}>
                                <MuiAutocomplete
                                    multiple
                                    id="checkboxes-tags-demo"
                                    options={gateArr}
                                    value={selectedGate}
                                    disableCloseOnSelect
                                    size="small"
                                    getOptionLabel={(option) => option.name}
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            setSelectedGate(newValue)
                                        } else {
                                            setSelectedGate(null)
                                        }
                                    }}
                                    renderOption={(props, option, { selected }) => {
                                        const { key, ...optionProps } = props;
                                        return (
                                            <li key={key} {...optionProps}>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                {option.name}
                                            </li>
                                        );
                                    }}
                                    sx={{ width: 300, '& fieldset': { borderRadius: '30px' } }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Secured/Unsecured" />
                                    )}
                                />
                            </Paper>
                            {selectedSector || selectedGate.length > 0 || selectedOperativeLead ?
                                <Tooltip title="Clear Filters">
                                    <Paper
                                        sx={{ display: 'flex', borderRadius: '5px', marginLeft: 2, width: 100, }}
                                    >
                                        <Button size='small' onClick={() => clearFilters()} > Clear Filter</Button>
                                    </Paper>
                                </Tooltip>
                                : null}
                            </Box> : null}
                        {/* <DrawingManager
                            onLoad={onLoadDrawingManager}
                            onOverlayComplete={onOverlayComplete}
                            options={drawingManagerOptions}
                            onMarkerComplete={(marker) => console.log(marker)}
                            onCircleComplete={(circle) => console.log(circle)}
                            onPolylineComplete={(polyline) => { console.log(polyline) }}
                            onRectangleComplete={(rectangle) => console.log(rectangle)}
                            onPolygonComplete={(polygon) => { getAreaforPolygon(polygon); setPolygons(polygon); showMarkers(polygon.latLngs.Eg[0].Eg, bounds) }}
                        /> */}
                        <MarkerClusterer
                            options={{
                                styles: [{
                                    url: process.env.PUBLIC_URL + '/cluster_images/m1.png',
                                    height: 66,
                                    width: 66,
                                    textColor: 'white',
                                },
                                {
                                    url: process.env.PUBLIC_URL + '/cluster_images/m2.png',
                                    height: 77,
                                    textColor: 'white',
                                    width: 77,
                                },
                                {
                                    url: process.env.PUBLIC_URL + '/cluster_images/m3.png',
                                    height: 88,
                                    width: 88,
                                    textColor: 'white',

                                }],
                                averageCenter: true,
                                gridSize: 60,
                                maxZoom: 15,
                                zoomOnClick: true,
                            }}
                        >
                            {clusterer => (
                                <div>
                                    <div>
                                        {markers.length > 0 ?
                                            <div>
                                                {markers.map((location, index) => (
                                                    <div>
                                                        <Marker
                                                            key={index}
                                                            position={location.latitude ? { lat: Number(location.latitude), lng: Number(location.longitude) } : null}
                                                            onClick={() => { handleActiveMarker(index, location.latitude, location.longitude, location.id) }}
                                                            zIndex={1000}
                                                            clusterer={clusterer}

                                                        >
                                                            {activeMarker === location.id ? (
                                                                <InfoWindow
                                                                    // ref={infowindowRef}
                                                                    // onLoad={infowindow => { infowindowRef.current = infowindow; }}
                                                                    onCloseClick={() => {
                                                                        setActiveMarker(null);
                                                                        // if (infowindowRef.current) {
                                                                        //     infowindowRef.current.close();
                                                                        // }
                                                                    }}
                                                                    position={location.path}>
                                                                    <div style={{ color: 'black', height: '250px', width: '250px' }}>
                                                                        <h2>{location.name}</h2>
                                                                        <div style={{ color: 'black' }}>
                                                                            <p><b>Opportunity Id:</b> {location.opportunity_id}</p>
                                                                            <p><b>Contract No:</b> {location.contract_no}</p>
                                                                            <p><b>Project Code:</b> {location.project_code}</p>
                                                                            <p><b>Gate Level Achieved:</b> {location.gate_level_acheived_name}</p>
                                                                            <p><b>ITT Due Date:</b> {location.itt_due_date ? moment(location.itt_due_date).format('DD-MM-YYYY') : null}</p>
                                                                            <p><b>Tender Submit Date:</b> {location.tender_submit_date ? moment(location.tender_submit_date).format('DD-MM-YYYY') : null}</p>
                                                                            <p><b>Contract Start Date:</b> {location.contractor_start_date ? moment(location.contractor_start_date).format('DD-MM-YYYY') : null}</p>
                                                                            <p><b>Contract End Date:</b> {location.contractor_end_date ? moment(location.contractor_end_date).format('DD-MM-YYYY') : null}</p>
                                                                            <p><b>Client Name:</b >{location.ptd_account_name}</p>
                                                                            <p><b>Sales Stage:</b> {location.sales_stage_name}</p>
                                                                            <p><b>Distribution Type:</b> {location.sales_status}</p>
                                                                            <p><b>Tender Value:</b> {location.tender_value ?  new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(location.tender_value) : ' - '}</p>
                                                                            <p><b>BB Project Value:</b> {location.bb_project_value ?  new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(location.bb_project_value) : ' - '}</p>
                                                                            <p><b>ITT Start Date:</b> {location.itt_start_date ? moment(location.itt_start_date).format('DD-MM-YYYY') : null}</p>
                                                                            <p><b>Sales Lead:</b >{location.sales_lead}</p>
                                                                            <p><b>EXpected Award Date:</b> {location.expected_award_date ? moment(location.expected_award_date).format('DD-MM-YYYY') : null}</p>
                                                                            <p><b>Discipline:</b> {location.sub_sector_name}</p>
                                                                            <p><b>Scope of Work:</b> {location.scope_of_work}</p>
                                                                            <p><b>Submission Margin %:</b> {location.submission_margin}</p>
                                                                            <p><b>Division:</b> {location.market_sub_vertical_name}</p>
                                                                            <p><b>Operations Lead:</b> {location.owner_delivery_name}</p>
                                                                            <p><b>Sub Division:</b> {location.owner_region_sector_name}</p>
                                                                            <p><b>Description:</b> {location.description}</p>
                                                                            <p><b>Opporunity Type:</b> {location.opportunity_type_name}</p>
                                                                            <p><b>Location:</b> {location.location}</p>
                                                                            <p><b>Start on Site Date:</b >{location.start_on_site_date ? moment(location.start_on_site_date).format('DD-MM-YYYY') : null}</p>
                                                                            <p><b>Contract Award Value:</b> {location.contract_award_value ?  new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(location.contract_award_value) : ' - '}</p>
                                                                            <p><b>Latitude:</b> {location.latitude}</p>
                                                                            <p><b>Longitude:</b> {location.longitude}</p>
                                                                            <p><b>W3W:</b> {location.w3w}</p>
                                                                        </div>
                                                                    </div>
                                                                </InfoWindow>) : null}
                                                        </Marker>
                                                    </div>
                                                ))}
                                            </div> : null}
                                    </div>
                                </div>
                            )
                            }
                        </MarkerClusterer>
                        <Box sx={{ position: 'absolute', top: 0, left: 20, display: 'flex', flexDirection: 'row' }}>

                            {/* <Autocomplete
                                onLoad={onLoadAutocomplete}
                                onPlaceChanged={handlePlaceChanged}
                                options={{
                                    // types: ['(regions)', 'address', '(cities)', 'geocode'],
                                    componentRestrictions: { country: "uk" },
                                    fields: ['place_id', 'geometry', 'name'],


                                }}

                            >
                                <div >
                                    <input
                                        type='text'
                                        placeholder='Search Location'
                                        style={inputStyle}

                                    />
                                </div>
                            </Autocomplete> */}
                        </Box>
                    </GoogleMap>
                </div> : null

    );
});

export default withSnackbar(MapComponent)